<div class="min-h-screen flex flex-col"
	style="background-image: url('/images/marble_texture.png'); background-size: cover; background-position: center;">

	<img src="/images/marbleBorder.png" alt="" style="width: 100%; height: 20px; display: block; object-fit: cover; flex-shrink:0;" />

	<div class="flex flex-1 items-start justify-center px-8 py-10">
		<div class="w-full" style="max-width: 780px;">

			<div class="mb-8 text-center">
				<h1 style="font-family: var(--font-family-display); font-size: 1.5rem; font-weight: 600; letter-spacing: 0.12em; color: var(--color-aegean-700);">
					<span ro-i18n eikey="login.brandName">The Socrates Initiative</span>
				</h1>
				<div style="width: 60px; border-top: 1px solid var(--color-gold-500); margin: 8px auto;"></div>
			</div>

			<div class="rounded-lg shadow-2xl overflow-hidden"
				style="border: 6px solid var(--color-sandstone); outline: 1px solid var(--color-gold-500);">

				<img src="/images/marbleBorder.png" alt="" style="width: 100%; height: 20px; display: block; object-fit: cover;" />

				<div style="background-image: url('/images/marble_texture.png'); background-size: cover; padding: 40px 50px 40px;">

					<h2 class="mb-6 text-2xl font-semibold" style="color: var(--color-charcoal); font-family: var(--font-family-display); letter-spacing: 0.03em;">
						<span ro-i18n eikey="legal.guidelines.title">Community Guidelines</span>
					</h2>

					<!-- Purpose -->
					<div class="mb-6">
						<h3 class="mb-2 text-sm font-semibold" style="color: var(--color-aegean-700); font-family: var(--font-family-display);">
							<span ro-i18n eikey="legal.guidelines.purpose.heading">Our Purpose</span>
						</h3>
						<p class="text-sm leading-relaxed" style="color: var(--color-charcoal); font-family: var(--font-family-ui);">
							<span ro-i18n eikey="legal.guidelines.purpose.body"></span>
						</p>
					</div>

					<!-- What We Ask of You -->
					<div class="mb-6">
						<h3 class="mb-3 text-sm font-semibold" style="color: var(--color-aegean-700); font-family: var(--font-family-display);">
							<span ro-i18n eikey="legal.guidelines.expectations.heading">What We Ask of You</span>
						</h3>
						<ul class="space-y-2">
							@for (key of expectations; track key) {
								<li class="flex gap-2 text-sm leading-relaxed" style="color: var(--color-charcoal); font-family: var(--font-family-ui);">
									<span style="color: var(--color-gold-600); flex-shrink: 0;">—</span>
									<span>{{ getMessage('legal.guidelines.expectations.' + key) }}</span>
								</li>
							}
						</ul>
					</div>

					<!-- What Is Not Acceptable -->
					<div class="mb-6">
						<h3 class="mb-3 text-sm font-semibold" style="color: var(--color-aegean-700); font-family: var(--font-family-display);">
							<span ro-i18n eikey="legal.guidelines.prohibited.heading">What Is Not Acceptable</span>
						</h3>
						<ul class="space-y-2">
							@for (key of prohibited; track key) {
								<li class="flex gap-2 text-sm leading-relaxed" style="color: var(--color-charcoal); font-family: var(--font-family-ui);">
									<span style="color: var(--color-terra-600); flex-shrink: 0;">×</span>
									<span>{{ getMessage('legal.guidelines.prohibited.' + key) }}</span>
								</li>
							}
						</ul>
					</div>

					<!-- Enforcement -->
					<div class="mb-6">
						<h3 class="mb-2 text-sm font-semibold" style="color: var(--color-aegean-700); font-family: var(--font-family-display);">
							<span ro-i18n eikey="legal.guidelines.enforcement.heading">Enforcement</span>
						</h3>
						<p class="text-sm leading-relaxed" style="color: var(--color-charcoal); font-family: var(--font-family-ui);">
							<span ro-i18n eikey="legal.guidelines.enforcement.body"></span>
						</p>
					</div>

					<div class="mt-8 pt-6" style="border-top: 1px solid var(--color-sandstone);">
						<a href="javascript:window.close()"
							class="text-sm underline"
							style="color: var(--color-aegean-600); font-family: var(--font-family-ui);">
							← Back to sign up
						</a>
					</div>

				</div>

				<img src="/images/marbleBorder.png" alt="" style="width: 100%; height: 20px; display: block; object-fit: cover;" />
			</div>

		</div>
	</div>

	<img src="/images/marbleBorder.png" alt="" style="width: 100%; height: 20px; display: block; object-fit: cover; flex-shrink:0;" />
</div>
